import React, { useState } from "react";

const UserAddress = (props) => {
    const {
        userAddress = [],
        handleAddressSelect,
        handleAddAddressClick,
        onEdit,
        selectedAddressId,
    } = props;

    const [visibleCount, setVisibleCount] = useState(3);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleShowMore = () => {
        setVisibleCount(userAddress.length);
        setIsExpanded(true);
    };

    const handleShowLess = () => {
        setVisibleCount(3);
        setIsExpanded(false);
    };

    return (
        <div>
            <div className="box-border">
                <span className="text-white">
                    Select a delivery address from your address book or enter a new one for delivery.
                </span>

                {userAddress?.length > 0 ? (
                    userAddress?.slice(0, visibleCount).map((item, i) => {
                        const addressId = item?.id || i;
                        const checked =
                            String(selectedAddressId) === String(addressId);

                        return (
                            <div className="mt-4" key={addressId}>
                                <div className="d-flex justify-content-between align-items-start">
                                    <div
                                        className="isLoggedIn_data d-flex align-items-start"
                                        style={{ gap: "10px" }}
                                    >
                                        <input
                                            type="radio"
                                            id={`selectaddress-${addressId}`}
                                            name="selectaddress"
                                            className="mt-2 select_address_button"
                                            value={addressId}
                                            checked={checked}
                                            onChange={() => handleAddressSelect(addressId)}
                                        />

                                        <div className="isLoggedIn_address">
                                            <span className="userName_address">
                                                {item?.contact_person_name || "N/A"}
                                            </span>

                                            <h6 className="text-white my-1">
                                                {item?.phone || "N/A"}
                                            </h6>

                                            <span className="mb-0 text-white d-block">
                                                {item?.address || "N/A"}
                                            </span>

                                            <span className="mb-0 text-white d-block mt-1">
                                                {item?.city || ""}
                                                {item?.state ? `, ${item.state}` : ""}
                                                {item?.zip ? ` - ${item.zip}` : ""}
                                            </span>

                                            <span className="mb-0 text-white d-block mt-1">
                                                {item?.country || "India"}
                                            </span>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => onEdit(item)}
                                        className="edit_button"
                                    >
                                        <img src="./images/edit.svg" alt="edit" />
                                    </button>
                                </div>

                                <div className="address_bottom_border"></div>
                            </div>
                        );
                    })
                ) : (
                    <div className="mt-4">
                        <span className="text-white">No address found.</span>
                    </div>
                )}
            </div>

            <div className="add_more_address_btn mt-2 d-flex gap-2 flex-wrap">
                <button
                    type="button"
                    className="web_buttons"
                    onClick={handleAddAddressClick}
                >
                    + Address
                </button>

                {visibleCount < userAddress?.length && !isExpanded && (
                    <button
                        type="button"
                        className="web_buttons"
                        onClick={handleShowMore}
                    >
                        Show More...
                    </button>
                )}

                {isExpanded && userAddress?.length > 3 && (
                    <button
                        type="button"
                        className="web_buttons"
                        onClick={handleShowLess}
                    >
                        Show Less
                    </button>
                )}
            </div>
        </div>
    );
};

export default UserAddress;
